<div class="partner-profile-email-event-block">
    <div>
        <img class="partner-profile-email-img" src="{{adminUrl}}XpressApp/assets/images/partner/profile/email-tab/daily-digest.png" />
    </div>
    <div class="partner-profile-email-text-block">
        <div class="partner-profile-email-title">Daily Digest</div>
        <div class="partner-profile-email-text">Store Performance for the previous week</div>
    </div>
    <div class="filler"></div>
    <div>
        <p-inputSwitch [disabled]="true"></p-inputSwitch>
    </div>
</div>

<div class="partner-profile-email-event-block">
    <div>
        <img class="partner-profile-email-img" src="{{adminUrl}}XpressApp/assets/images/partner/profile/email-tab/weekly-report.png" />
    </div>
    <div class="partner-profile-email-text-block">
        <div class="partner-profile-email-title">Weekly Report</div>
        <div class="partner-profile-email-text">Daily updates about your business including Store Sales and Performance</div>
    </div>
    <div class="filler"></div>
    <div>
        <p-inputSwitch [disabled]="true"></p-inputSwitch>
    </div>
</div>

<div class="partner-profile-email-event-block">
    <div>
        <img class="partner-profile-email-img" src="{{adminUrl}}XpressApp/assets/images/partner/profile/email-tab/monthly-business-report.png" />
    </div>
    <div class="partner-profile-email-text-block">
        <div class="partner-profile-email-title">Monthly Business Report</div>
        <div class="partner-profile-email-text">How your business has performed over the past month</div>
    </div>
    <div class="filler"></div>
    <div>
        <p-inputSwitch [disabled]="true"></p-inputSwitch>
    </div>
</div>

<div class="partner-profile-email-event-block">
    <div>
        <img class="partner-profile-email-img" src="{{adminUrl}}XpressApp/assets/images/partner/profile/email-tab/xpress-promotions.png" />
    </div>
    <div class="partner-profile-email-text-block">
        <div class="partner-profile-email-title">Xpress Promotions</div>
        <div class="partner-profile-email-text">Upcoming Promotions on Xpress for your business</div>
    </div>
    <div class="filler"></div>
    <div>
        <p-inputSwitch [disabled]="true"></p-inputSwitch>
    </div>
</div>

<div class="partner-profile-email-event-block">
    <div>
        <img class="partner-profile-email-img" src="{{adminUrl}}XpressApp/assets/images/partner/profile/email-tab/weekly-statements.png" />
    </div>
    <div class="partner-profile-email-text-block">
        <div class="partner-profile-email-title">Weekly Statements</div>
        <div class="partner-profile-email-text">Daily updates about your business including Store Sales and Performance</div>
    </div>
    <div class="filler"></div>
    <div>
        <p-inputSwitch [disabled]="true"></p-inputSwitch>
    </div>
</div>
